$(document).ready(function () {

  var button = $('#pronunciation-button');
  var audio = $('#pronunciation-audio')[0];

  button.on('click', function () {
    if (audio.paused) {
      audio.play();
    }
    else {
      audio.pause();
    }
  })
})